import { render, staticRenderFns } from "./make-payment.vue?vue&type=template&id=3e8ba6b2&scoped=true&"
import script from "./make-payment.vue?vue&type=script&lang=js&"
export * from "./make-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ba6b2",
  null
  
)

export default component.exports